import React from "react"
import request from "../util/request"
import SearchBar from "../legacy_components/SearchBar"
import webify from "../util/webify"

export default class PassengerSearch extends React.Component {
  constructor(props) {
    super(props)
  }

  performLookup = (query) => {
    return request("POST", this.props.searchEndpointPath, {q: query})
  }

  renderSearchResultRow = (r, _resetSearchState) => {
    return (
      <a
        className="block px-2 py-2 hover:no-underline hover:bg-gray-100"
        key={`${r.user_id}-${r.person_id}`}
        href={r.result_url}
        data-role="search-result-link"
      >
        <div className="font-bold">{r.person_full_name || r.email}</div>
        <div className="inline-block text-gray-700">{r.email}</div>
      </a>
    )
  }

  render() {
    return (
      <div className="search-bar">
        <SearchBar
          renderSearchResultRow={this.renderSearchResultRow}
          performLookup={this.performLookup}
          placeholder={this.props.placeholder || "Passenger Search..."}
        />
      </div>
    )
  }
}

webify("passenger-search", PassengerSearch)
